import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

const ToastMsg = ({ message, type = 'success', duration = 3000, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const getIconClass = () => {
    switch (type) {
      case 'success':
        return 'fa-solid fa-check-circle';
      case 'error':
        return 'fa-solid fa-times-circle';
      case 'warning':
        return 'fa-solid fa-exclamation-triangle';
      default:
        return 'fa-solid fa-info-circle';
    }
  };

  const getBackgroundColor = () => {
    switch (type) {
      case 'success':
        return '#4CAF50';
      case 'error':
        return '#f44336';
      case 'warning':
        return '#ff9800';
      default:
        return '#2196F3';
    }
  };

  // Le JSX du toast
  const toastContent = (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        backgroundColor: getBackgroundColor(),
        color: 'white',
        padding: '10px 20px',
        borderRadius: '8px',
        boxShadow: '0px 0px 10px rgba(0,0,0,0.2)',
        zIndex: 9999999,
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
      }}
    >
      <i className={getIconClass()} style={{ fontSize: '1.2rem' }} aria-hidden="true"></i>
      <span>{message}</span>
    </div>
  );

  // Rendu via portal directement dans <body>
  return ReactDOM.createPortal(toastContent, document.body);
};

export default ToastMsg;
